<script>
    import { Image, FormGroup, Input, Button } from 'sveltestrap';

    export let server;
    export let token = undefined;
    export let login = '';
    export let password = '';
    let errorString = '';

    async function getToken(event) {
		const response = await fetch(server + "/cgi-bin/auth.pl", {
            method: 'GET',
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Authorization': "Basic " + btoa(login + ":" + password)
            }
        });

		const token = await response.text();

		if (response.ok) {
		    return token;
		} else {
		    throw new Error(response.status);
		}
    }

    function handleSubmit(event) {
        errorString = '';
        if (!login || !password)
            return;
        let tokenPromise = getToken(event);
        tokenPromise.then((response) => {
            token = response;
        });
        tokenPromise.catch((error) => {
            errorString = "Connection error: " + error;
        });
    }

    document.title = "Restricted area";
</script>

<div>
    <img alt="EasyPlayout" src="./easyplayout.png" />
    <div id="login">
        <form on:submit|preventDefault={handleSubmit}>
            <FormGroup>
                <Input type="text" bind:value={login} name="login" placeholder="Login" />
            </FormGroup>
            <FormGroup>
                <Input type="password" bind:value={password} name="password" placeholder="Password" />
            </FormGroup>
            <Button type="submit" color="primary">Connect</Button>
        </form>
        {#if errorString}
            <p class="error">{errorString}</p>
        {/if}
    </div>
</div>

<style>
    div {
        text-align: center;
	}
    #login {
        width: 30em;
        margin-left: auto;
        margin-right: auto;
        border: 2px solid #CCCCCC;
        padding: 2em;
    }
    img {
        width: 30em;
        margin-left: auto;
        margin-right: auto;
    }
    .error {
        margin-top: 1em;
        font-weight: bold;
        color: red;
    }
</style>